export default "__VITE_ASSET__Bg7KAR8l__"